<template>
  <div id="sidebar">
    <div class="sidebar-logo" @click="vHome()">
      <img :src="logo" />
    </div>
    <div class="sidebar-container">
      <SideMenu />
      <Identite :key="nRenderKey" />
      <a class="btn" href="#" @click="vDeconnexion()">{{$_('deconnect')}}</a>
    </div>
    <div class="close-sidebar">
      <span @click="vCloseSidebar">
        <i class="material-icons">arrow_back</i>
      </span>
    </div>
  </div>
</template>

<script>
import SideMenu from "@/common/components/widget/Menu/SideMenu.vue";
import Identite from "@/common/components/widget/Identite.vue";

import customerService from '@/modules/client/services/customerService'

import { Bus } from "@/common/Bus";

export default {
  components: {
    SideMenu,
    Identite
  },
  data() {
    return {
      link: Array(),
      bLightDisplay: false,
      nRenderKey: 0,
      logo: '',
    };
  },
  created() {

    this.getDivLogo();
    
    if (
      this.$router.history.current.name === "society" ||
      this.$router.history.current.name === "customer"
    ) {
      this.bLightDisplay = true;
    }

    Bus.$on("renderIdentite", () => {
      ++this.nRenderKey;
    });
  },
  methods: {
    vHome() {
      this.$router.push("/");
      Bus.$emit("openSidebar");
      Bus.$emit("overlay");
    },
    vCloseSidebar() {
      Bus.$emit("openSidebar");
      Bus.$emit("overlay");
    },
    vDeconnexion() {
      localStorage.removeItem("satabapp-research");
      localStorage.removeItem("satabapp-company");
      localStorage.removeItem("satabapp-user");
      localStorage.removeItem("satabapp-token");
      localStorage.removeItem("satabapp-customer");
      localStorage.removeItem("satabapp-translation");

      document.location.reload(true);
    },
    getDivLogo() {
      customerService.getDivLogo()
      .then(res => {
        this.logo = res.data
      })
    }
  }
};
</script>

<style scoped>
#sidebar {
  min-width: 230px;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #fff;
  overflow: scroll;
}
/* #sidebar.sticky {
    position: fixed;
    height: auto;
} */
.sidebar-logo {
  padding: 30px;
}
.picto-satab {
  height: 74px;
  display: flex;
  align-items: center;
  background-color: #f00b35;
  width: 100%;
  justify-content: center;
}
.picto-satab img {
  width: 50px;
}
.society-logo {
  border-bottom: solid 1px #e9e9e9;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 0px;
}
.society-logo img {
  max-width: 130px;
}
.btn-deconnect-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex: 1;
}
.sidebar-container {
  flex: 1;
  text-align: center;
}
.close-sidebar {
  padding: 15px 25px;
  display: none;
  justify-content: flex-end;
}
@media (max-width: 800px) {
  .close-sidebar {
    display: flex;
    position: absolute;
    bottom: 0;
    background: #fff;
    border-top: solid 1px grey;
    width: 100%;
  }
  .sidebar-logo {
    padding:0px;
    margin: auto;
  }
  .sidebar-logo img {
    padding: 30px;
    max-width: 170px;
  }
  #sidebar .sidebar-container {
    overflow: scroll;
    padding-bottom: 50px;
  }
}

@media (max-width: 1370px) {
  #sidebar {
    max-width: 100% !important;
    width: 100%;
    height: 100vh !important;
  }
  .close-sidebar {
    display: flex;
    background: #fff;
    border-top: solid 1px grey;
    width: 100%;
    margin-top: 15px;
  }
}
</style>